module.exports = __webpack_public_path__ + "e1bc2ea28807b80dac5a9fc28185406d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/Xay_Dung_Website.svg
// module id = ./assets/images/advisory/Xay_Dung_Website.svg
// module chunks = 0